import p from "../../../../@babel/runtime/helpers/esm/typeof2.mjs";
import y from "../rule/index.mjs";
var u = function(o, r, a, i, t) {
  var e = [], f = Array.isArray(r) ? "array" : p(r);
  y.required(o, r, i, e, t, f), a(e);
};
export {
  u as default
};
//# sourceMappingURL=required.mjs.map
